import { render } from "./InstitucionalView.vue?vue&type=template&id=2bcd5b1c&scoped=true"
import script from "./InstitucionalView.vue?vue&type=script&lang=js"
export * from "./InstitucionalView.vue?vue&type=script&lang=js"

import "./InstitucionalView.vue?vue&type=style&index=0&id=2bcd5b1c&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcd5b1c"]])

export default __exports__